<div class="container mt-5">
    <div class="text-center hero my-5">
        <img class="mb-3 app-logo" src="../../assets/logo.png" alt="Tin Arm logo" />
        <h1 class="mb-4">FMEDA</h1>

        <p class="lead">
            FMEDA workspace from
            <a href="https://www.tinarmengineering.com/">Tin Arm</a>
        </p>
    </div>
</div>

@if (auth.isAuthenticated$ | async) {
<div class="nav"><a [routerLink]="['/projects']" [queryParams]="{ create: 1 }" placement="end"
        ngbTooltip="Create a new project">+</a></div>
<div>
    @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
        {{apiError}}
    </div>
    }
    <div class="projectTiles">
        @for (project of this.projects; track project.id) {
        <a class="projectTile" href="javascript:void(0)" (click)="openProject(project)">
            <div class="projectTileContent">
                <div class="projectImage" [attr.data-risk]="getRiskLevel(project.id)">
                    <svg viewBox="0 0 50 150" xmlns="http://www.w3.org/2000/svg" class="reliability-graph">
                        <!-- Define gradient for center node -->
                        <defs>
                            <radialGradient [attr.id]="'centerGradient-' + project.id" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" [attr.stop-color]="getRiskColor(getRiskLevel(project.id))" stop-opacity="0.9" />
                                <stop offset="100%" [attr.stop-color]="getRiskColor(getRiskLevel(project.id))" stop-opacity="0.6" />
                            </radialGradient>
                        </defs>
                        <!-- Connecting lines -->
                        <line x1="25" y1="30" x2="12" y2="60" stroke="#999" stroke-width="1" opacity="0.5"></line>
                        <line x1="25" y1="30" x2="38" y2="60" stroke="#999" stroke-width="1" opacity="0.5"></line>
                        <line x1="25" y1="30" x2="25" y2="65" stroke="#999" stroke-width="1" opacity="0.5"></line>
                        <line x1="25" y1="30" x2="12" y2="100" stroke="#999" stroke-width="1" opacity="0.4"></line>
                        <line x1="25" y1="30" x2="38" y2="100" stroke="#999" stroke-width="1" opacity="0.4"></line>
                        <!-- Central system node -->
                        <circle cx="25" cy="30" r="6" [attr.fill]="'url(#centerGradient-' + project.id + ')'" stroke="#fff" stroke-width="1.5"></circle>
                        <!-- Component nodes (top level) -->
                        <circle cx="12" cy="60" r="4" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.7" stroke="#fff" stroke-width="0.8"></circle>
                        <circle cx="38" cy="60" r="4" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.7" stroke="#fff" stroke-width="0.8"></circle>
                        <circle cx="25" cy="65" r="4" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.7" stroke="#fff" stroke-width="0.8"></circle>
                        <!-- Component nodes (lower level) -->
                        <circle cx="12" cy="100" r="3" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.5" stroke="#fff" stroke-width="0.8"></circle>
                        <circle cx="38" cy="100" r="3" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.5" stroke="#fff" stroke-width="0.8"></circle>
                        <!-- Bottom decorative nodes -->
                        <circle cx="8" cy="130" r="2" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.4" stroke="#fff" stroke-width="0.6"></circle>
                        <circle cx="25" cy="135" r="2" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.4" stroke="#fff" stroke-width="0.6"></circle>
                        <circle cx="42" cy="130" r="2" [attr.fill]="getRiskColor(getRiskLevel(project.id))" opacity="0.4" stroke="#fff" stroke-width="0.6"></circle>
                    </svg>
                </div>
                <div class="projectDetails">
                    <div class="projectCreation">
                        @if (project.created_at) {
                        {{project.created_at | date:'HH:mm, dd MMM yyyy'}}
                        }
                    </div>
                    <div class="projectTitle">
                        {{project.name}}
                    </div>
                    <div class="projectMeta">
                        {{project.id}}
                    </div>
                    <div class="projectMeta">
                        {{project.owner_type === 'ORGANISATION' ? ('Org: ' + (project.owner_org_id || 'unknown')) :
                        'Owner: Me'}}
                    </div>
                </div>
            </div>
        </a>
        }
    </div>
</div>
}